"use strict";
// Types derived from http://cql.hl7.org/04-logicalspecification.html#typespecifier
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=type-specifiers.interfaces.js.map